// extracted by mini-css-extract-plugin
export default {"cardCont":"MasterDataCard_cardCont__GSi3z","btns":"MasterDataCard_btns__NN6Z8"};